import { OutstandingLoadTenderTotal } from "../../../../../datafusion/src/widgets/OutstandingLoadTenderTotal";
import { CustomerServiceToolPanel } from "../CustomerServiceToolPanel";
import { DataSource, Layout, LayoutHeader, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCustomerService extends Layout {
    layoutCustomerServiceToolPanel: CustomerServiceToolPanel;
    layoutOutstandingLoadTenderTotal: OutstandingLoadTenderTotal;
    layoutheaderCustomerService: LayoutHeader;
    panelSecondaryFilters: Panel;
    sourceCustomerServiceMovements: DataSource;
    tableCustomerServiceMovements: Table;
    textboxDateRange: Textbox;
}
